import { useTranslation } from 'react-i18next';

const flags = {
  pl: 'https://flagcdn.com/w40/pl.png',
  en: 'https://flagcdn.com/w40/gb.png',
  ar: 'https://flagcdn.com/w40/eg.png'
};

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const languages = [
    { code: 'pl', label: 'Polski' },
    { code: 'en', label: 'English' },
    { code: 'ar', label: 'العربية' }
  ];

  return (
    <div className="flex gap-2">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => changeLanguage(lang.code)}
          className={`relative w-8 h-8 rounded-full overflow-hidden border-2 transition-all duration-200 ${
            i18n.language === lang.code
              ? 'border-[#DC143C] scale-110'
              : 'border-gray-200 hover:border-gray-300'
          }`}
          title={lang.label}
        >
          <img
            src={flags[lang.code]}
            alt={lang.label}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;